import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentReturnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment_return"}/>
}
